import {
	DmViewerReducer,
	ExtremeGridReducer,
	FormsReducer,
	HubConnectionReducer,
	LoginReducer,
	ModalManagerReducer,
	SystemReducer,
	UITourReducer,
	UploadManagerReducer
} from '@bimser/common';
import { AsyncReducers, IBaseAction } from '@bimser/core';
import { executeAsyncReducers } from 'app-init';
import { WebInterfaceBaseState, WebInterfaceBaseStateFactory } from '../common/base/state';
import ESignatureReducer from '../common/components/ESignature/reducers';

const initialState = WebInterfaceBaseStateFactory();

function RootReducer(
	state: WebInterfaceBaseState = initialState,
	action: IBaseAction<any>
): WebInterfaceBaseState {
	return state.withMutations(state => {
		state
			.set('system', SystemReducer(state.system, action))
			.set('user', LoginReducer(state.user, action))
			.set('modals', ModalManagerReducer(state.modals, action))
			.set('hubConnection', HubConnectionReducer(state.hubConnection, action))
			.set('Viewers', DmViewerReducer(state.Viewers, action))
			.set('forms', FormsReducer(state.forms, action))
			.set('ExtremeGrid', ExtremeGridReducer(state.ExtremeGrid, action))
			.set('UploadManager', UploadManagerReducer(state.UploadManager, action))
			.set('UITour', UITourReducer(state.UITour, action))
			.set('ESignature', ESignatureReducer(state.ESignature, action));

		executeAsyncReducers(RootReducer.asyncReducers, state, action);
	});
}

namespace RootReducer {
	export const asyncReducers: AsyncReducers<
		'layouts' | 'modules' | 'user' | 'shared' | 'Viewers'
	> = {};
}

export default RootReducer;
